
import {Component, Vue, Watch} from 'vue-property-decorator';
import AdminChangePassword from '@/modules/Admins/ChangePassword.vue';
import {Admin} from '../../stores/Admins';
import NevronHeader from '@/components/NevronHeader.vue';
import stores from '../../stores';
import Skeleton from '@/modules/Skeleton.vue';
import NevronInput from '@/components/NevronInput.vue';
import {Role} from "@/stores/Roles";
import {Feature} from "@/stores/Features";
import {showToaster} from "@/components/DashboardComposer/helpers";
import { translate } from '@/helpers/functions';

@Component({
  components: {
    NevronHeader,
    Skeleton,
    NevronInput,
  },
})

export default class AdminDetails extends Vue {
  role: Role = new Role();
  featuresList: Feature[] = [];

  /*
   *
   */
  @Watch('$route', {immediate: true, deep: true})
  changePage() {
    this.fetchData(this.$route.params.id);
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    this.fetchData(this.$route.params.id);
  }

  get groupedFeatures() {
    const groups: { [key: string]: IFeature[] } = {};
    this.featuresList.forEach((feature) => {
      if (!groups[feature.group]) {
        groups[feature.group] = [];
      }
      groups[feature.group].push(feature);
    });
    return groups;
  }

  getPermissionValue(permissionKey: string): any {
    return this.role.permissions.includes(permissionKey);
  }

  updatePermissionValue(permissionKey: string, value: any) {
    const index = this.role.permissions.indexOf(permissionKey);

    if (index !== -1) {
      if(value === false) {
        this.role.permissions.splice(index, 1);
      }
    } else {
      if(value === true) {
        this.role.permissions.push(permissionKey);
      }
    }
  }

  /*
   *
   */
  fetchData(id: string) {
    Role.getById(id)
      .then((role) => {
        this.role = role;
        stores.features.getAll().then((response) => {
          this.featuresList = response;
        })
      })
      .catch((reason) => {
        console.log('Could not fetch role', reason);
        if (!this.role.id) {
          this.$router.push({name: 'access.roles'});
        }
      });
  }

  /*
   *
   */
  onSubmit() {
    const data = {
      id: this.role.id,
      name: this.role.name,
      permissions: this.role.permissions,
    };
    if(this.role.permissions.length === 0)
    {
      showToaster('danger','', translate("required-atleast-one") || "Atleast one field is required.", translate("permissions") || 'Permissions');
      return;
    }
    return stores.roles.update(data)
      .then((response) => {
        if (response && response.success) {
          showToaster('success', this.role.name, 'successfully updated');
        }
        let error = response;
        if (!response.success && error.response.status === 422) {
          let msg = error.response.data.errors
          if(error.response.data.errors.name)
          {
            msg = error.response.data.errors.name
          }
          showToaster('danger', '', msg , error.response.status);
          return
        }
        if (!response.success && error.response.status >= 400 && error.response.status < 500) {
          showToaster('danger', '', error.response.data.error.message , error.response.status);
        }
      });
  }

  /*
   *
   */
  removeRole() {
    if (this.role.id) {
      return stores.roles.delete(this.role.id)
        .then(() => {
          console.log('Success');
          this.$router.push('/custom-roles?page=1');
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }


}
